import React from "react";
import { Icon } from "../core/Icon.jsx";
import { Button } from "../core/Button.jsx";

/** One event of the day — ceremony, cocktail, reception — with venue, time and a map action. */
export function EventCard({ icon = "church", title, time, venue, address, note, actionLabel = "Ver ubicación", onAction, tone = "default", style }) {
  const fg = tone === "onDark" ? "var(--fg-on-contrast)" : "var(--fg-primary)";
  const muted = tone === "onDark" ? "color-mix(in srgb, var(--fg-on-contrast) 66%, transparent)" : "var(--fg-secondary)";
  return (
    <article style={{
      display: "grid", justifyItems: "center", gap: "var(--sp-3)", textAlign: "center",
      padding: "var(--sp-6) var(--sp-5)",
      border: "var(--border-hair) solid var(--rule)",
      background: tone === "onDark" ? "transparent" : "var(--bg-elevated)",
      ...style,
    }}>
      <Icon name={icon} size={32} style={{ color: "var(--accent)" }} />
      <h3 style={{ margin: 0, fontFamily: "var(--font-title, var(--font-display))", fontWeight: "var(--fw-regular)", fontSize: "var(--fs-title-s)", letterSpacing: "var(--ls-wide)", textTransform: "uppercase", color: fg }}>{title}</h3>
      {time && <p style={{ margin: 0, fontFamily: "var(--font-caps)", fontSize: "var(--fs-caption)", letterSpacing: "var(--ls-wider)", color: "var(--accent)" }}>{time}</p>}
      {venue && <p style={{ margin: 0, fontSize: "var(--fs-body-s)", color: fg }}>{venue}</p>}
      {address && <p style={{ margin: 0, fontSize: "var(--fs-caption)", lineHeight: "var(--lh-snug)", color: muted, maxWidth: 260 }}>{address}</p>}
      {note && <p style={{ margin: 0, fontSize: "var(--fs-micro)", fontStyle: "italic", color: muted }}>{note}</p>}
      {onAction && (
        <Button variant="outline" size="sm" tone={tone} onClick={onAction} style={{ marginTop: "var(--sp-2)" }}>{actionLabel}</Button>
      )}
    </article>
  );
}
